// extracted by mini-css-extract-plugin
export default {"container":"FriendRequest_container__iHHO5","btn":"FriendRequest_btn__2dCZY"};